import React from 'react';
import PropType from 'prop-types';
import classNames from "classnames";

export default class Color extends React.Component
{
    static propTypes = {
        value: PropType.string.isRequired,

        onBlur: PropType.func.isRequired,
        onChange: PropType.func.isRequired,
    };

    render()
    {
        const { className, ...otherProps } = this.props;

        const classes = classNames(
            className,
            "h-8 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 cursor-pointer border border-gray-300 rounded-md",
        );

        return  <input
            type="color"
            className={classes}
            value={this.props.value}
            onChange={this.props.onChange}
            onBlur={this.props.onBlur}
            {...otherProps}
        />;
    }
}
